import React, { useState } from "react";
import Icon from "../AppIcon";

/**
 * Modal for activating a distribution rule with an effective date
 */
const RuleActivationModal = ({
  isOpen,
  onClose,
  onConfirm,
  ruleName,
  loading = false,
}) => {
  // Default to tomorrow at 00:00
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);

  const [effectiveDate, setEffectiveDate] = useState(
    tomorrow.toISOString().slice(0, 16)
  );
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const handleConfirm = () => {
    const selectedDate = new Date(effectiveDate);
 const now = new Date();

    if (selectedDate <= now) {
  setError("Effective date must be in the future.");
return;
    }

    setError(null);
    onConfirm(selectedDate);
  };

  const minDate = new Date();
  minDate.setMinutes(minDate.getMinutes() + 5);
  const minDateStr = minDate.toISOString().slice(0, 16);

  return (
    <div className="fixed inset-0 z-[1200] flex items-center justify-center">
      {/* Backdrop */}
    <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
   />

      {/* Modal */}
      <div className="relative bg-background rounded-lg shadow-xl w-full max-w-md">
     {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
       <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-success/10 flex items-center justify-center">
      <Icon name="Zap" size={20} className="text-success" />
          </div>
            <div>
              <h2 className="text-lg font-semibold">Activate Rule</h2>
            <p className="text-sm text-muted-foreground">{ruleName}</p>
            </div>
    </div>
   <button
  onClick={onClose}
            className="p-2 hover:bg-muted rounded-full transition-colors"
          >
      <Icon name="X" size={20} />
</button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <div className="bg-warning/10 border border-warning/20 rounded-lg p-4">
       <div className="flex items-start gap-3">
  <Icon
          name="AlertTriangle"
                size={20}
     className="text-warning shrink-0 mt-0.5"
         />
              <div className="text-sm">
    <p className="font-medium mb-1">Important:</p>
     <ul className="list-disc list-inside space-y-1 text-muted-foreground">
          <li>
           Only <strong>Tenant Administrators</strong> can activate
   rules.
               </li>
              <li>
        When this rule is activated, all other rules for the same
        location will be deactivated.
                  </li>
          <li>The effective date must be in the future.</li>
         </ul>
       </div>
            </div>
          </div>

          <div>
  <label className="label">Effective From *</label>
         <input
         type="datetime-local"
           value={effectiveDate}
              onChange={(e) => {
  setEffectiveDate(e.target.value);
     setError(null);
    }}
   min={minDateStr}
       className="input w-full"
            />
         <p className="text-xs text-muted-foreground mt-1">
  The rule will become active at this date and time.
          </p>
          {error && (
              <p className="text-sm text-error mt-2">
            <Icon name="AlertCircle" size={14} className="inline mr-1" />
       {error}
         </p>
 )}
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 p-4 border-t border-border bg-muted/30">
          <button
       className="btn btn-outline"
     onClick={onClose}
     disabled={loading}
          >
     Cancel
          </button>
          <button
     className="btn btn-success"
  onClick={handleConfirm}
      disabled={loading}
          >
            {loading ? (
    <>
   <div className="spinner spinner-sm" />
      Activating...
       </>
) : (
 <>
<Icon name="Zap" size={18} />
       Activate Rule
  </>
      )}
       </button>
        </div>
      </div>
    </div>
  );
};

export default RuleActivationModal;
